import { render, staticRenderFns } from "@/manager/convocation/views/convocationDetail/convocationDetail.pug?vue&type=template&id=0062ddd6&scoped=true&lang=pug&external"
import script from "./convocationDetail.view.vue?vue&type=script&lang=ts"
export * from "./convocationDetail.view.vue?vue&type=script&lang=ts"
import style0 from "@/manager/convocation/views/convocationDetail/convocationDetail.scss?vue&type=style&index=0&id=0062ddd6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0062ddd6",
  null
  
)

export default component.exports